import { Typography } from '@material-ui/core'
import GatewayIcon from '@material-ui/icons/CreditCard'

import PageHeader from '../../components/PageHeader'
import { getTranslate } from '../../localization'
import useStyles from './styles/GatewayAddHeader.styles'

export const GatewayAddHeader = () => {
  const classes = useStyles()
  const title = 'Add New Gateway'

  return (
    <>
      <PageHeader title={getTranslate(title)} />
      <div className={classes.header}>
        <GatewayIcon fontSize="large" />
        <Typography className={classes.title} variant="h3" gutterBottom>
          {getTranslate(title)}
        </Typography>
      </div>
    </>
  )
}
export default GatewayAddHeader
